import { createStore } from "vuex";

export default createStore({
  state: {
    member: {
      jwt: false
    },
    from: null
  },
  mutations: {
    storeMember(state, data) {
      state.member = data;
    },
    storeFrom(state, from) {
      state.from = from;
    }
  },
  actions: {
    login(context, data) {
      context.commit("storeMember", data);
    },
    logout(context) {
      context.commit("storeMember", { jwt: false });
    },
    from(context, page) {
      context.commit("storeFrom", page);
    }
  },
  modules: {}
});
